import React, { Suspense } from 'react';

import type { FiltersToggleProps } from './index';

// Keep store dependencies out of the navigation skeleton's initial bundle.
const FiltersToggleLazy = React.lazy(() =>
	import(
		/* webpackChunkName: "@atlaskit-internal_@atlassian/search-page/quick-find-filter-toggle" */ './index'
	).then(({ FiltersToggle }) => ({ default: FiltersToggle })),
);

export const FiltersToggle = (props: FiltersToggleProps): React.JSX.Element => (
	<Suspense fallback={null}>
		<FiltersToggleLazy {...props} />
	</Suspense>
);
